import { inject } from 'vue'

/**
 * Composable to use localization in a component with automatic namespace lookup
 * @param namespaceList {string[]}
 * @returns {{l10n: LocaleService, t: ((function(string, *): (*|string))|*)}}
 */
export default function useLocalization(namespaceList = []) {
  /** @type {LocaleService} */
  const l10n = inject('l10n')

  /**
   * @param key {string}
   * @param options
   * @returns {*|string|string}
   */
  const t = (key, options) => {
    for (const namespace of namespaceList) {
      const translation = l10n.translate(key, {...options, namespace})
      if (translation !== key) {
        return translation
      }
    }
    return l10n.translate(key, options)
  }

  return {
    t,
    l10n
  }
}
